import { mapGetters } from 'vuex';

export default {
    name: 'guideNavigation',
    computed: {
        ...mapGetters('glb', ['glb']),
        ...mapGetters('guide', ['guide']),
        geo() {
            var geo = this.guide.geo;
            if (geo) {
                return geo;
            }
        },
    }
};